import React from 'react'
import { reactular } from '@vendhq/reactular'
import { SaleFooter } from './sale-footer/sale-footer'
import { SaleSummary } from './sale-summary/sale-summary'
import { SaleCustomerSearch } from './sale-customer-search/sale-customer-search'
import { SalePayments } from './sale-payment/sale-payment'
import { SaleBanner } from './sale-banner/SaleBanner'

export const SaleView: React.FC = () => {
  return (
    <div className="sale" data-testid="react_sale_view">
      <>
        <SaleCustomerSearch />
        <SaleBanner />
        <div className="sale-body" aria-label="sale-body">
          <SaleSummary />
          <SaleFooter />
        </div>
        <SalePayments />
      </>
    </div>
  )
}

export const ReactSaleViewComponent = reactular(SaleView, [], 'reactWrapper')
